import {
  CONTENT_CENTER_CREATION_PATH_A,
  DECORATION_PATH_A,
  DYNAMIC_PATH_A,
  PUBLISH_CASE_AUDIT_PATH_A,
  PUBLISH_CASE_PATH_A,
  PUBLISH_MEAL_PATH_A,
  PUBLISH_MEAL_REVIEW_PATH_A,
  SCHEDULETOOL_PATH_A,
  SELLERSERVICE_PATH_A,
  STATISTIC_TASK_CENTER_TASK
} from '@constant'
import {
  isWeddingDressPhotoProperty,
  isWeddingDressProperty,
  isWeddingPlanProperty
} from '@merchant-backend/util'
import Img from '@UI/Img'
import { HLJ_STATISTIC } from '@util'
import cls from 'classnames'
import { Flex } from 'hljd'
import React, { Component } from 'react'
import {
  TASK_FINISH,
  TASK_TODO,
  TASK_UNPASS,
  TASK_VERIFY
} from '../../constant'
import style from './style.module.less'

export default class extends Component {
  getTaskInfo = status => {
    switch (status) {
      case TASK_TODO:
        return {
          className: style['btn-todo'],
          text: '去完成',
          onClick: this.goToTask
        }

      case TASK_FINISH:
        return {
          className: style['btn-finish'],
          text: '已完成',
          onClick: undefined
        }

      case TASK_VERIFY:
        return {
          className: style['btn-todo'],
          text: '审核中',
          onClick: this.goToTask
        }

      case TASK_UNPASS:
        return {
          className: style['btn-todo'],
          text: '未通过',
          onClick: this.goToTask
        }

      default:
        break
    }
  }

  goToTask = () => {
    let { entity, status } = this.props

    HLJ_STATISTIC({
      page_name: '商家端任务中心',
      element_tag: STATISTIC_TASK_CENTER_TASK,
      data_id: entity
    })

    let path = ''

    switch (entity) {
      case 'EmceeSchedule':
        // 创建档期
        path = SCHEDULETOOL_PATH_A
        break

      case 'Example':
        // 发布案例
        path = PUBLISH_CASE_PATH_A
        if (status == 3) {
          // 审核中
          path = PUBLISH_CASE_AUDIT_PATH_A
        }
        if (status == 4) {
          // 审核未通过
          path = PUBLISH_CASE_AUDIT_PATH_A + '?type=3'
        }
        break

      case 'Package':
        // 发布套餐
        path = PUBLISH_MEAL_PATH_A
        if (status == 3) {
          // 审核中
          path = PUBLISH_MEAL_REVIEW_PATH_A
        }
        if (status == 4) {
          // 审核未通过
          path = PUBLISH_MEAL_REVIEW_PATH_A + '?type=3'
        }
        break

      case 'Merchant':
        // 完善店铺信息
        path = DECORATION_PATH_A + '?type=background'
        break

      case 'Note':
        // 动态
        path = DYNAMIC_PATH_A
        if (
          isWeddingDressProperty() ||
          isWeddingPlanProperty() ||
          isWeddingDressPhotoProperty()
        ) {
          // 这三种商家跳转到我的创作
          path = CONTENT_CENTER_CREATION_PATH_A
        }
        break

      case 'WeixinBond':
        // 绑定微信
        path = SELLERSERVICE_PATH_A
        break

      case 'MerchantNotice':
        // 设置店铺公告
        path = DECORATION_PATH_A + '?type=notice'
        break

      default:
        break
    }
    path && window.open(path)
  }

  render() {
    const { title, status, desc } = this.props

    const { className, text, onClick } = this.getTaskInfo(status)

    return (
      <Flex className={style.item} sp>
        <div className={style.content}>
          <div className={style.title}>{title}</div>
          <div className={style.intro}>{desc}</div>
        </div>

        <div className={cls(style.action, 'v-center')}>
          {status == TASK_FINISH ? (
            <img
              src="//qnm.hunliji.com/FvU6PEpJHKleZkMShCBb5EFSc9Q8"
              alt=""
              width="60"
            />
          ) : (
            <div className={cls(style.btn, className)} onClick={onClick}>
              {text}
            </div>
          )}
        </div>

        <Img
          src="//qnm.hunliji.com/o_1d681s65em9h1vqpnk4lpf1cp7e.png"
          style={{
            width: 116,
            height: 34,
            position: 'absolute',
            right: 50,
            bottom: 0
          }}
        />
      </Flex>
    )
  }
}
